<template>
  <div class="icon-text">
    <div class="icon-text__icon-wrapper">
      <BaseIcon
        :icon="icon"
        class="icon-text__icon"
      />
    </div>
    <div class="icon-text__text">
      {{ text }}
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/Base/BaseIcon'

export default {
  name: 'IconText',
  components: {
    BaseIcon
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-text {
  display: flex;
  align-items: center;

  &__icon-wrapper {
    width: 21px;
    height: 21px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__icon {}
  &__text {
    margin-left: 8px;
  }
}
</style>
